import Schema from 'AppReact/schema';
import { unitMin, category, priority } from 'types';

export default {
  selectedCategoryIds: Schema('integer', 'array', { defaultValue: [] }),
  selectedUnitIds: Schema('integer', 'array', { defaultValue: [] }),
  selectedPriorityIds: Schema('integer', 'array', { defaultValue: [] }),
  waitingOnParts: Schema('boolean', 'primitive', { defaultValue: false }),
  noAccess: Schema('boolean', 'primitive', { defaultValue: false }),
  postErrorOrders: Schema('boolean', 'primitive', { defaultValue: false }),
  activeOrders: Schema('boolean', 'primitive', { defaultValue: false }),
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  priorities: Schema(priority, 'array', { defaultValue: [] }),
  units: Schema(unitMin, 'array', { defaultValue: [] }),
  categories: Schema(category, 'array', { defaultValue: [] }),
  selectedTab: Schema('string', 'primitive-nullable', { defaultValue: '' }),
  isCallback: Schema('boolean', 'primitive', { defaultValue: false }),
};
